import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status?: ReduxStateType;
  data: any;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  data: {},
};

const evaluateCampaignSlice = createSlice({
  name: "evaluateCampaign",
  initialState,
  reducers: {
    evaluateCampaignStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    evaluateCampaignSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload.data;
    },
    evaluateCampaignFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetEvaluateCampaign: (state) => {
      state.status = ReduxStateType.INIT;
      state.data = {};
    },
  },
});

export const {
  evaluateCampaignStart,
  evaluateCampaignSuccess,
  evaluateCampaignFailed,
  resetEvaluateCampaign,
} = evaluateCampaignSlice.actions;

export default evaluateCampaignSlice.reducer;
